import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getWishlist, toggleWishlist } from '../api/wishlistApi';
import { isLoggedIn } from '../utils/tokenUtils';
import styles from './WishlistPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function WishlistPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn()) { navigate('/login'); return; }
        getWishlist()
            .then(res => setItems(res.data))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const handleRemove = async (productId) => {
        try {
            await toggleWishlist(productId);
            setItems(prev => prev.filter(item => item.productId !== productId));
        } catch { alert('오류가 발생했습니다.'); }
    };

    if (loading) return <p style={{ textAlign: 'center', padding: '80px' }}>로딩 중...</p>;

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>찜한 상품</h2>
            {items.length === 0 ? (
                <div className={styles.empty}>
                    <p>찜한 상품이 없습니다.</p>
                    <button onClick={() => navigate('/products')} className={styles.shopBtn}>쇼핑하러 가기</button>
                </div>
            ) : (
                <div className={styles.grid}>
                    {items.map(item => (
                        <div key={item.wishlistId} className={styles.card}>
                            <div className={styles.imageWrap} onClick={() => navigate(`/products/${item.productId}`)}>
                                <img src={`${API_URL}${item.imageUrl}`} alt={item.name} className={styles.image} />
                            </div>
                            <div className={styles.info}>
                                <p className={styles.name} onClick={() => navigate(`/products/${item.productId}`)}>{item.name}</p>
                                <p className={styles.price}>{item.price?.toLocaleString()}원</p>
                                <div className={styles.btnRow}>
                                    <button onClick={() => navigate(`/products/${item.productId}`)} className={styles.detailBtn}>상품 보기</button>
                                    <button onClick={() => handleRemove(item.productId)} className={styles.removeBtn}>♥ 찜 해제</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default WishlistPage;